module.exports = __webpack_public_path__ + "static/media/nl-NL.6fb38d46.md";